export type SupportTab = { id: string; label: string; to: string }

export const SUPPORT_TABS: SupportTab[] = [
  { id: 'community-links', label: 'Community Links', to: '/support/community-links' },
  { id: 'outreach', label: 'Link Follow-ups', to: '/support/outreach' },
  { id: 'chatbot', label: 'Chatbot', to: '/support/chatbot' },
]
